import { render, staticRenderFns } from "./FollowUpHistoryResult.vue?vue&type=template&id=54ff1e42"
import script from "./FollowUpHistoryResult.vue?vue&type=script&lang=js"
export * from "./FollowUpHistoryResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports